import { Directive } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
  selector: '[hlmAttachmentActions],hlm-attachment-actions',
  host: { 'data-slot': 'attachment-actions' },
})
export class HlmAttachmentActions {
  constructor() {
    classes(
      () =>
        'shrink-0 items-center relative z-20 flex group-data-[orientation=vertical]/attachment:absolute group-data-[orientation=vertical]/attachment:end-3 group-data-[orientation=vertical]/attachment:top-3 group-data-[orientation=vertical]/attachment:gap-1',
    );
  }
}
